import styles from "../style/footer.module.scss";

export default function Footer() {
    return (
        <div className={styles.footer}>
            <div className={styles.footer__logo}>
                <h2>Simple</h2>
            </div>
        </div>
    );
}
